import { render, staticRenderFns } from "./ModalMigrateContact.vue?vue&type=template&id=67ce6a0c"
import script from "./ModalMigrateContact.vue?vue&type=script&lang=js"
export * from "./ModalMigrateContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports